export { default } from "./BookingDetail";

